var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('O3D',{attrs:{"layout":"overall"}},_vm._l((_vm.fruits),function(fruit){return _c('O3D',{key:fruit._id,attrs:{"layout":fruit.name}},[_c('Fruit',{attrs:{"name":fruit.name,"url":fruit.url}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }